//import { IsNotEmpty, IsString } from "class-validator";

import { IsBoolean, IsNotEmpty, IsString } from "class-validator";
import { RegionInfoDto } from "../region/region.dto";
import { CityInfoDto } from "../city";

export class CreateCountryDto {
  @IsString()
  @IsNotEmpty()
  name: string;
}

export class CountryDto extends CreateCountryDto {
  id: number;
}

export class CountryInfoDto {
  id: number;
  name: string;
  publishingDataId: number | null;
}

export class UpdateCountryBasicDataDto {
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class RegionWithCitiesDto extends RegionInfoDto {
  cities: CityInfoDto[];
}

export class CountryAdvancedDto extends CountryDto {
  regions: RegionWithCitiesDto[];
}